export const GOOGLE_FONT_LOADING_SUCCESS = "app/GOOGLE_FONT_LOADING_SUCCESS";